import React from 'react';
import styled from 'styled-components';
import { TrevorComponent, WithIcon } from '../../types';

export const TitleRaw: TrevorComponent<WithIcon> = ({
  children,
  className,
  icon,
}) => (
  <h3 className={className}>
    {icon}
    <span>{children}</span>
  </h3>
);

export const Title = styled(TitleRaw)`
  --color: #061e2d;
  --font-size: 14px;
  --line-height: 20px;

  margin: 0;

  span {
    color: var(--color);
    font-size: var(--font-size);
    font-weight: bold;
    line-height: var(--line-height);
  }

  svg {
    fill: var(--color);
    margin-right: 10px;
  }
`;
